import {useHistory} from "react-router-dom";
import React, {useState, useEffect} from 'react';

function SuccessPage() {
    const history = useHistory();

    useEffect(function() {
        setTimeout(function () {
            BX24.fitWindow();
        }, 500)
    }, []);

    return (
        <div className="SuccessPage">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="title">
                            Поздравляем! Все данные импортированы в Битрикс 24.
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-6 logob24">
                        <img src="/img/monitor.png" alt=""/>
                    </div>
                    <div className="col-6 story">
                        <p>С Битрикс24 ваш отдел продаж будет работать как часы.</p>

                        <p>По вопросам внедрения CRM Битрикс24 для вашей компании, вы можете обращаться по нашей <a
                            target="blank" href="mailto:bitrix24@severcode.ru">электронной почте</a>.</p>

                        <p>Команда <a href="https://www.severcode.ru" target="_blank"><img src="/img/severcode.png"
                                                                                           alt="SeverCode"/></a></p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2 offset-10 text-right">
                        <div className="paging">
                            5 / 5
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SuccessPage;
